import React from 'react'
import { useIntl } from 'react-intl'
import { Heading2, Page, Text } from '../../../components/layout'
import { messages } from '../messages'

interface Props {
  message: string
}

export const ShiftErrorPage: React.FunctionComponent<Props> = ({ message }) => {
  const { formatMessage } = useIntl()
  return (
    <Page>
      <Heading2>{formatMessage(messages.errorPageHeading)}</Heading2>
      <Text>{message}</Text>
    </Page>
  )
}
